import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PullDataStateService {
  private productData = new BehaviorSubject<any>(null);

  setData(data: any) {
    this.productData.next(data);
  }

  getData() {
    return this.productData.value;
  }

  clear() {
    this.productData.next(null);
  }
}
